import { render, staticRenderFns } from "./CourseActive.vue?vue&type=template&id=2e3dcf8e&"
import script from "./CourseActive.vue?vue&type=script&lang=js&"
export * from "./CourseActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports